import configuration from './../config.json'
import CarsGroupsService from './../shared/services/carsGroupsService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const RESPONSE_CARS_GROUPS = 'RESPONSE_CARS_GROUPS'
const REQUEST_CARS_GROUPS_FAILURE = 'REQUEST_CARS_GROUPS_FAILURE'

const responseGetCarsGroupsAction = (data) => {
  return {
    type: RESPONSE_CARS_GROUPS,
    data,
  }
}

const requestGetCarsGroupsfailureAction = (errors) => {
  return {
    type: REQUEST_CARS_GROUPS_FAILURE,
    errors,
  }
}

const getCarsGroups = () => {
  return (dispatch) => {
    CarsGroupsService.getCarsGroups()
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)
        
        dispatch(responseGetCarsGroupsAction(result.data.groups))
      })
      .catch((error) => {
        dispatch(requestGetCarsGroupsfailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  getCarsGroups,
  responseGetCarsGroupsAction,
  requestGetCarsGroupsfailureAction,
  RESPONSE_CARS_GROUPS,
  REQUEST_CARS_GROUPS_FAILURE,
}
